// The ONLY place colors live. Components import tokens and never write a color
// literal inline. To re-skin the widget (e.g. to a Postgres-flavored blue),
// edit this file and nothing else.
//
// Token groups follow spec §10: Brand · Status · Text · Surfaces/borders ·
// Shadows · Geometry.

/* ── Brand ─────────────────────────────────────────────────────────────── */

export const BRAND_COLOR = "#1976D2";
export const BRAND_COLOR_DARK = "#1565C0"; // hover
export const BRAND_COLOR_TEXT = "#1565C0"; // brand-colored text / active nav label
export const BRAND_COLOR_TINT = "rgba(25, 118, 210, 0.10)"; // icon tiles, active nav, chips, table heads
export const BRAND_COLOR_TINT_SOFT = "rgba(25, 118, 210, 0.05)"; // info panels, hover rows

/* ── Status ────────────────────────────────────────────────────────────── */

export const SUCCESS_COLOR = "#2E7D32";
export const SUCCESS_COLOR_DARK = "#1B5E20";
export const SUCCESS_TINT = "rgba(46, 125, 50, 0.10)";

export const WARNING_COLOR = "#ED6C02";
export const WARNING_COLOR_DARK = "#E65100";
export const WARNING_TINT = "rgba(237, 108, 2, 0.12)";
export const WARNING_TINT_SOFT = "rgba(237, 108, 2, 0.06)"; // "In Progress" chips

export const ERROR_COLOR = "#D32F2F";
export const ERROR_COLOR_DARK = "#C62828"; // hover
// Solid, not a tint. Where it is used — the danger-zone revoke card — it is the
// only thing marking the card as destructive, and a low-alpha red over white
// composites to a pale wash indistinguishable from BORDER_LIGHT.
export const ERROR_BORDER = ERROR_COLOR;

/* ── Text ──────────────────────────────────────────────────────────────── */

export const TEXT_PRIMARY = "rgba(0, 0, 0, 0.87)";
export const TEXT_SECONDARY = "rgba(0, 0, 0, 0.60)";
export const TEXT_MUTED = "rgba(0, 0, 0, 0.50)";
export const TEXT_FAINT = "rgba(0, 0, 0, 0.38)";
export const TEXT_DISABLED = "rgba(0, 0, 0, 0.26)";
export const TEXT_ON_DARK = "#FFFFFF";

/* ── Surfaces & borders ────────────────────────────────────────────────── */

// The page canvas, the sidebar and the loader are transparent so the widget
// blends into Zoho's page behind the iframe (§5). Note §12.15: this only shows
// through if the production iframe actually allows transparency.
export const PAGE_BG = "transparent";

// Content cards are OPAQUE white (§5) — they sit on top of the transparent
// canvas and carry the actual content, so they stay readable regardless of
// what Zoho paints behind the iframe.
export const SURFACE = "#FFFFFF";
export const SURFACE_TINT = "#FAFAFA"; // pinned dialog footers, table heads
// Floating surfaces: dialog, modal, menu, popover, autocomplete. These are
// drawn over arbitrary page content and must never be transparent.
export const SURFACE_OVERLAY = "#FFFFFF";

// Deliberately unfilled. Spec §5 calls for a "transparent danger-zone Revoke
// card" — it sits on an opaque card and is defined by its red outline alone.
export const SURFACE_TRANSPARENT = "transparent";

export const INFO_PANEL_BG = BRAND_COLOR_TINT_SOFT; // helper/explainer panels
export const CHIP_NEUTRAL_BG = "rgba(0, 0, 0, 0.06)";

export const BORDER_LIGHT = "rgba(0, 0, 0, 0.08)"; // card outline
export const BORDER = "rgba(0, 0, 0, 0.12)"; // inputs, dividers between sections
export const BORDER_DARK = "rgba(0, 0, 0, 0.23)"; // outlined input resting state
export const DIVIDER = "rgba(0, 0, 0, 0.12)";

/* ── Shadows ───────────────────────────────────────────────────────────── */

export const CARD_SHADOW = "none";
export const CARD_SHADOW_HOVER = "rgba(149, 157, 165, 0.2) 0px 8px 24px";
export const BUTTON_SHADOW = "0px 3px 1px -2px rgba(0, 0, 0, 0.20)";

/* ── Geometry ──────────────────────────────────────────────────────────── */

export const CARD_RADIUS = "10px";
export const BUTTON_RADIUS = "8px";
export const TILE_RADIUS = "8px";
export const CARD_BORDER = `1px solid ${BORDER_LIGHT}`;
